var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bee-handy-table',{attrs:{"headers":_vm.headers,"items":[],"dense":"","zebra":"","hide-default-footer":"","items-per-page":-1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }